<template>
  <div class="search" :class="{ focused: isFocused }">
    <div class="search-inner">
      <div
        class="dropdown-label"
        v-show="!isFocused"
        @click.stop="showDropAction"
      >
      <!-- :class="{ 'no-drop': !isAll }" v-show="isAll"-->
        <span>{{ theTypesData.name }}</span>
        <i class="iconfont iconxiala-copy" v-if="searchTypes.length > 1"></i>
        <div class="dropdown" v-if="showDrop && searchTypes.length > 1">
          <ul class="dropdown-ul">
              <li
              :class="{active: theTypesData.type === item.type}"
              v-for="(item,index) in searchTypes" :key="index + 'type'"
              @click.stop="chooseDrop(item)">{{item.name}}</li>
          </ul>
        </div>

      </div>
      <div class="input-outer">
        <i class="iconfont iconsousuo to-search" @click.stop="enterSearch"></i>
        <input
          :value="keyVal"
          type="text"
          ref="search-input"
          maxlength="12"
          :placeholder="placeholderText"
          @keyup.enter.stop="enterSearch"
          @keydown.stop
          @keyup.stop
          @input.stop="toSearch"
          @click.stop="onFocus"
          @paste.stop
        />
        <i
          class="iconfont iconguanbianniu2 clear"
          @click="toClear"
          v-show="keyVal !== ''"
        ></i>
      </div>
    </div>
    <searchTip v-model="showTip" @select="chooseKeyword"></searchTip>
  </div>
</template>

<script>
/* 交互 1.退出分类搜索的三种操作 a.点清空按钮x b.手动删空文案并按回车 c.切换到别的分类，再切回来
 交互 2.只有按enter或搜索按钮，才触发搜索 */
import searchTip from '../resourcesArea/searchTip.vue';

export default {
  name: "Search",
  model: {
    prop: "keyVal",
    event: "inputAction",
  },
  props: {
    isFocused: {
      type: Boolean,
      default: false,
    },
    keyVal: {
      type: String,
      default: "",
    },
    searchTypes: {
      type: Array,
      default: () => {
        return [
          {
            type: "all",
            name: "全部",
          },
          {
            type: "collect",
            name: "收藏",
          },
        ];
      },
    },
    currentTab: {
      type: String,
      default: "all",
    },
    placeholderText: {
      type: String,
      required: true,
    },

    searchAction: { type: Function, required: true },
    clearAction: { type: Function, required: false }, // 开放功能
    mode: { type: String, default: "" },
    isisDefaultAll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showDrop: false,
      showTip: false,
      timer: null,
      theTypesData: {
        type: 'all',
        name: '全部'
      },
    };
  },
  computed: {
  },
  components: {
    searchTip
  },
  created() {
    if (!this.isDefaultAll) {
      this.theTypesData = this.searchTypes[0];
    }
  },
  watch: {
    searchTypes (nv) {
      if (!this.isDefaultAll) {
        this.theTypesData = nv[0];
      }
    }
  },
  mounted () {
    document.body.addEventListener('click', () => {
      this.showTip = false;
      this.showDrop = false;
      if (this.keyVal === '') {
        if(this.isFocused) {
          this.$emit("onFocus", false);
          this.searchAction("", this.theTypesData);
        }
      }
    }, false);
  },
  methods: {
    showDropAction () {
      this.showDrop = true;
    },
    chooseKeyword ({item, type}) {
      this.$emit("inputAction", type === 'hot' ? item.name: item.value);
      setTimeout(() => {
        this.enterSearch();
      })
    },
    toClear() {
      this.$emit("inputAction", "");
      this.searchAction("", this.theTypesData);
      this.$emit("onFocus", false);
      setTimeout(() => {
        this.$refs["search-input"].blur();
        this.showTip = false;
      }, 100);
    },
    chooseDrop(item) {
      this.theTypesData = item;
      this.showDrop = false;
    },
    toSearch(e) {
      this.$emit("inputAction", e.target.value);
    },
    enterSearch(e) {
      if (this.keyVal === "") {
        this.toClear();
        return;
      }
      this.searchAction(this.keyVal, this.theTypesData);
      this.$refs['search-input'].focus();
      // 存储搜索词
      let list = this.$util.localStorage.get("SEARCH_history_record") || [];
      let newList = list.filter((item) => item.value !== this.keyVal && item.value !== '');
      newList.unshift({value: this.keyVal});
      newList = newList.slice(0, 5);
      let data = JSON.stringify(newList);
      this.$util.localStorage.set("SEARCH_history_record", data);
       setTimeout(() => {
        this.showTip = false;
      }, 30);
      this.$bus.emit('resourcesArea.enterSearch', this.keyVal)
    },
    onFocus () {
      this.$emit('onFocus', true);
      this.showTip = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.search {
  width: 100%;
  background-color: #fff;
  position: relative;
  z-index: 2;
  &.focused {
    z-index: 21;
    .search-inner {
      border: 1px solid #5778FB;
      margin-right: 14px;
    }
    .input-outer {
      border-left: 0;
      border-radius: 4px;
      .clear {
        right: 10px;
      }
    }
  }
}

/deep/ .search-tip {
    left: 14px;
    top: -12px;
}
.dropdown-label {
  width: 56px;
  border-radius: 4px 0 0 4px;
}
.search-inner {
  height: 34px;
  border-radius: 4px;
  margin: 16px 40px 16px 14px;
  position: relative;
  border: 1px solid #d9ddea;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #F0F0F8;
  .input-outer {
    height: 100%;
    border-left: 1px solid #d9ddea;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 30px 0 30px;
    position: relative;
    flex-grow: 1;
    display: flex;
    align-items: center;
    border-radius: 0 4px 4px 0;
    input {
      display: block;
      width: 100%;
      height: 100%;
      color: #474261;
      font-size: 12px;
      border: 0;
      outline: none;
      &::input-placeholder {
        color: #d9ddea;
        opacity: 0.4;
      }
    }
    .clear {
      position: absolute;
      right: -20px;
      top: 10px;
      color: #737596;
      cursor: pointer;
      font-size: 10px;
      transform: scale(0.8);
    }
    .to-search {
      position: absolute;
      top: 9px;
      left: 8px;
      z-index: 5;
      color: #737596;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .dropdown {
    position: absolute;
    left: 0;
    top: 32px;
    padding-top: 6px;
    z-index: 20;
    display: block;
    &-ul {
        width: 88px;
        max-height: 328px;
        padding: 2px 0;
        background-color: #FFFFFF;
        box-shadow: 0px 2px 9px rgba(56, 58, 66, 0.2);
        border-radius: 4px;
        overflow-y: auto;
        text-align: left;
        box-sizing: border-box;
        &::-webkit-scrollbar {
            width: 7px;
            height: 7px;
            background-color: transparent;
            }
        &::-webkit-scrollbar-thumb {
            background-color: #ACA9A9;
            opacity: 0.65;
            border-radius: 7px;
        }
        li {
            font-size: 12px;
            padding: 0 18px;
            line-height: 36px;
            color: #474261;
            background-color: #FFFFFF;
            word-break: keep-all;
            &:hover {
                background-color: #F6F7F9;
            }
        }
    }
}
}
</style>



// WEBPACK FOOTER //
// src/components/common/search.vue